export default "__VITE_ASSET__CXNm1Gb8__"